export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.enabledReadBox,
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: that.disabled ? 80 : 110,
    slots: { default: 'opt' },
    className: 'col-opt',
  },
  {
    title: that.$l('table_label_ftyNoticeOutDocType') || '文档类型',
    field: 'ftyNoticeOutDocType',
    align: 'center',
    width: 150,
    editRender: {
      name: 'dict-select',
      props: {
        placeholder: that.$l('INDEX.tips_select_data') || '请选择...',
        body: { dictType: 'ftyNoticeOutDocType' },
        url: '/master/common/dict/biz',
        filterable: true,
        clearable: true,
        size: 'mini',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fileName') || '文件名',
    field: 'fileName',
    minWidth: 300,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_remark') || '备注说明',
    field: 'remark',
    align: 'left',
    headerAlign: 'center',
    minWidth: 300,
    editRender: {
      name: 'ElInput',
      props: {
        placeholder: that.$l('INDEX.tips_input_placeholder') || '请输入...',
        maxlength: 500,
        'show-word-limit': true,
        clearable: true,
        size: 'mini',
      },
    },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_uploadByName') || '上传人姓名',
    field: 'uploadByName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_uploadTime') || '上传时间',
    field: 'uploadTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
